export default __webpack_public_path__ + "static/logstore-ab52b6859365093bec805432ce5443ff.svg";